import { useTranslation } from "react-i18next";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";

import { NotificationCategoryEnum } from "../../enums/notifications";

import { getNotifications } from "../services/notifications";

export const useGetInfiniteNotifications = ({ category }: { category: NotificationCategoryEnum }) => {
  const { i18n } = useTranslation();

  return useInfiniteQuery({
    queryKey: ["Notifications", i18n.language, category],
    queryFn: ({ pageParam = 0 }) => getNotifications(pageParam, category),
    initialPageParam: 0,
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
    getNextPageParam: (lastPage, allPages) => {
      const totalPages = Math.ceil(lastPage.data.total / 10);
      const nextPage = allPages.length;
      return nextPage < totalPages ? nextPage : undefined;
    },
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchIntervalInBackground: true,
    placeholderData: keepPreviousData,
  });
};
